'use client';

import { useAtomValue } from 'jotai';
import Image from 'next/image';

import { Loader, tw } from '@repo/ui';
import {
  getImageUrl,
  roundToTwoSignificantDigitsWithMinDecimals,
} from '@repo/utils';

import { txIdAtom } from '@claim/atoms';
import { useDecompressedTokensValue } from '@claim/hooks/use-decompressed-tokens-value';

import { ClaimButton } from '../button';

export const ClaimSuccess: React.FC = () => {
  const txId = useAtomValue(txIdAtom);
  const { data, isLoading, isRefetching } = useDecompressedTokensValue(txId);

  const formattedAmount = roundToTwoSignificantDigitsWithMinDecimals(
    data?.[0]?.uiAmount ?? 0,
  ).toLocaleString();

  const showLoader =
    isLoading || isRefetching || !data?.[0]?.uiAmount || data[0].uiAmount === 0;

  return (
    <>
      <div className='relative w-[410px] max-w-[95vw] md:max-w-[100vw]'>
        <Image
          src={getImageUrl('/claim/images/floating-dood.png')}
          alt='success'
          width={410}
          height={420}
          layout='responsive'
        />
      </div>

      <div
        className={tw(
          'flex w-[105%] flex-col items-center rounded-xl bg-[#0B0B0B]',
          'border border-white/40 px-4 py-5 text-white md:py-10',
          '-mt-[7rem] shadow-md shadow-white/20',
        )}
      >
        <div className='z-10 flex w-full flex-col items-center justify-center'>
          <div className='relative'>
            {!showLoader ? (
              <p
                className={tw(
                  'z-10 -mb-2 text-[45px] font-bold md:mb-0 md:text-[88px]',
                )}
              >
                {formattedAmount}
              </p>
            ) : (
              <div className='py-4'>
                <Loader
                  theme='secondary'
                  size='xlarge'
                />
              </div>
            )}

            {!showLoader ? (
              <p
                className={tw(
                  'absolute inset-0 -mb-2 font-bold opacity-70 blur-xl',
                  'text-[45px] md:text-[88px]',
                )}
              >
                {formattedAmount}
              </p>
            ) : null}
          </div>
          <p
            className={tw('text-2xl font-semibold text-[#05FFA9] md:text-3xl')}
          >
            $DOOD CLAIMED
          </p>
          {txId ? (
            <a
              href={`https://solscan.io/tx/${txId}`}
              target='_blank'
              rel={'noopener noreferrer'}
              className='font-light text-white/50 underline'
            >
              View on Solscan
            </a>
          ) : null}
        </div>
      </div>

      <div className='mt-5 flex flex-col pb-10 md:px-12'>
        <div className='flex flex-col gap-4'>
          <div className='flex gap-4 md:items-center md:gap-8'>
            <div className='relative aspect-square h-[90px] min-w-[90px] overflow-hidden rounded-md bg-white/50 md:h-[135px] md:min-w-[135px]'>
              <Image
                src={getImageUrl('/claim/images/lord-of-the-files.png')}
                alt='lord-of-the-files'
                fill
                style={{
                  objectFit: 'cover',
                }}
              />
            </div>

            <div className='flex flex-col gap-1 md:gap-3'>
              <h3 className='text-lg font-semibold md:text-2xl'>
                LORD OF THE FILES
              </h3>
              <p className='text-xs font-light text-white/50 md:text-sm'>
                Join Databodata, Dullsville's 4th largest data processing firm.
                Feed content on X to your department head and attempt to stay
                alive with a pot starting at 500,000 $DOOD up for grabs. Passes
                available from 4pm ET May 9th until 4pm ET May 12th.
              </p>
              <a
                href='https://lordofthefiles.xyz/'
                target='_blank'
                rel='noopener noreferrer'
                className='hidden md:block'
              >
                <ClaimButton
                  text={'MINT YOUR PASS FOR 2000 $DOOD'}
                  hasEnoughSol={true}
                  hasSolWallet={true}
                />
              </a>
            </div>
          </div>
          <a
            href='https://lordofthefiles.xyz/'
            target='_blank'
            rel='noopener noreferrer'
            className='block md:hidden'
          >
            <ClaimButton
              text={'MINT YOUR PASS FOR 2000 $DOOD'}
              hasEnoughSol={true}
              hasSolWallet={true}
              className='block md:hidden'
            />
          </a>
        </div>

        <hr className='my-10' />

        <div className='flex flex-col gap-4'>
          <div className='flex gap-4 md:items-center md:gap-8'>
            <div className='relative aspect-square h-[90px] min-w-[90px] md:h-[135px] md:min-w-[135px]'>
              <Image
                src={getImageUrl('/claim/images/dreamnet.svg')}
                alt='dreamnet'
                fill
                style={{
                  objectFit: 'cover',
                }}
              />
            </div>
            <div className='flex flex-col gap-1 md:gap-3'>
              <h3 className='text-lg font-semibold md:text-2xl'>DREAMNET </h3>
              <p className='text-xs font-light text-white/50 md:text-sm'>
                Learn about the future of immersive storytelling and how $DOOD
                will create the first autonomous, decentralized universe.
              </p>
              <a
                href='https://dreamnet.doodles.app/'
                target='_blank'
                rel='noopener noreferrer'
                className='hidden md:block'
              >
                <ClaimButton
                  text={'READ THE WHITEPAPER'}
                  hasEnoughSol={true}
                  hasSolWallet={true}
                />
              </a>
            </div>
          </div>
          <a
            href='https://dreamnet.doodles.app/'
            target='_blank'
            rel={'noopener noreferrer'}
            className='block md:hidden'
          >
            <ClaimButton
              text={'READ THE WHITEPAPER'}
              hasEnoughSol={true}
              hasSolWallet={true}
            />
          </a>
        </div>
      </div>
    </>
  );
};
